import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { SlideAnimationProvider } from "contexts/SlideAnimation";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import StyledDialog from "components/Styled/Dialog";
import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";

import ConversationalTemplate from "./BentoAIFlow";

export default function CreateTemplate() {
  const { createTemplateDialogOpen, setCreateTemplateDialogOpen } = useContext(
    OutreachTemplatesContext,
  );
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    setCreateTemplateDialogOpen(false);
    if (isPage(routes.templates)) {
      navigate(`/${routes.templates}`);
    }
  };

  useEffect(() => {
    if (createTemplateDialogOpen) {
      trackEvent("Create Template Dialog Form - Opened", {
        route: location.pathname,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createTemplateDialogOpen]);

  return (
    <StyledDialog
      open={createTemplateDialogOpen}
      handleClose={handleClose}
      title={""}
    >
      <SlideAnimationProvider>
        <ConversationalTemplate />
      </SlideAnimationProvider>
    </StyledDialog>
  );
}
